import $ from 'jquery';
// https://github.com/thecreation/breakpoints-js
import Breakpoints from 'breakpoints-js';
import ezPlus from 'ez-plus';

const ezplus = {
    init() {
        ezplus.initEzPlus();
        $('.js-pdp-gallery').on('beforeChange', function () {
            ezplus.destroyEzPlus();
        });
        $('.js-pdp-gallery').on('afterChange', function () {
            ezplus.destroyEzPlus();
            ezplus.initEzPlus();
        });
    },
    initEzPlus() {
        if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
            ezplus.destroyEzPlus();
        }
        else {
            let $zoomImageContainer = $('#zoom-image-container');
            let width = $zoomImageContainer.width();
            let height = $zoomImageContainer.outerHeight();
            let offset = ($zoomImageContainer.outerWidth() - width)/2;
            $('.slick-active .image-for-zoom').ezPlus({
                responsive: true,
                zoomWindowPosition: 'zoom-image-container',
                zoomWindowHeight: height,
                zoomWindowWidth: width,
                zoomWindowOffsetX: offset,
                borderSize: 1,
                cursor: 'pointer',
                easing: true
            });
        }
    },
    destroyEzPlus() {
        $('.slick-active .image-for-zoom').each(function () {
            let plugin = $(this).data('ezPlus');
            if (plugin) {
                plugin.destroy();
                $('.zoomWindowContainer').remove();
            }
        });
    },
    initResize() {
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                ezplus.destroyEzPlus();
                ezplus.initEzPlus();
            }, 250);
        });
    }
};

// DOM ready
$(() => {
    if($('.productdetail-page').length) {
        ezplus.init();
        ezplus.initResize();
    }
});

export default ezplus;
